import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import CatProvider from "./contexts/CatContext";
import LangPovider from "./contexts/LangContext";
import App from './App';
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LangPovider>
        <CatProvider>
          <App />
        </CatProvider>
      </LangPovider>
    </BrowserRouter>
  </React.StrictMode>
);
